const messageConfig = {
    serviceID: 'service_gbldbhn',
    templateID: 'template_7p48w1f',
    userID: 'DXeeExu84I6_CEQaj',
  };
  
  export default messageConfig;